<template lang="pug">
  BarChart.bar-chart(
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :height="330"
      style="max-width:100%"
    )
</template>

<script>

import 'chartjs-adapter-date-fns';
import {
  Chart as ChartJS,
  BarElement,
} from 'chart.js';

import { Bar } from 'vue-chartjs/legacy';

ChartJS.register(BarElement);

export default {
  name: 'ChartBar',
  components: { BarChart: Bar },
  props: {
    data: Array,
    labels: Array,
  },
  data() {
    return {
      maxCols: 12,
    };
  },
  computed: {
    chartId() { return this._id; }, // eslint-disable-line no-underscore-dangle
    chartData() {
      return {
        labels: this.labels.slice(-this.maxCols),
        datasets: [
          {
            backgroundColor: '#33A1FB',
            data: this.data.slice(-this.maxCols),
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: this.externalTooltipHandler,
          },
        },
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      if (window.innerWidth < 576) {
        this.maxCols = 4;
      } else if (window.innerWidth < 768) {
        this.maxCols = 6;
      } else if (window.innerWidth < 992) {
        this.maxCols = 8;
      } else {
        this.maxCols = 12;
      }
    },
    externalTooltipHandler(context) {
      // Tooltip Element
      const { chart, tooltip } = context;
      const tooltipEl = this.getOrCreateTooltip(chart);

      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }

      const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
      tooltipEl.style.padding = '10px';
      tooltipEl.innerText = '';

      const value = tooltip.body?.[0].lines;

      const valueNode = document.createElement('div');
      valueNode.style.color = '#FFFFFF';
      valueNode.style.fontSize = '14px';
      valueNode.style.lineHeight = '17px';
      valueNode.style.textAlign = 'center';
      valueNode.innerText = `${value} ₽`;

      tooltipEl.appendChild(valueNode);
      tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
      tooltipEl.style.top = `${positionY + tooltip.caretY}px`;
      tooltipEl.style.opacity = 1;
    },
    getOrCreateTooltip(chart) {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, -40px)';
        tooltipEl.style.transition = 'all .1s ease';

        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    },
  },
};

</script>

<style scoped lang="scss">
.bar-chart {
  &, ::v-deep canvas {
    max-width: 100%;
  }
}
</style>
